<template>
  <div
    class="table-of-contents-container"
  >
    <div class="title-container">
      <div class="column">
        <p class="title">{{ reportDetails.name }}<span data-elev-selector="hotel-report" class="elevio-placeholder">&nbsp;</span></p>
      </div>
      <div v-if="isAzira" class="edit-mode-toggle">
        <b-icon
          class="edit-mode-icon"
          :class="{ active: editMode }"
          icon="pencil-square"
          :title="editMode ? 'Exit edit mode' : 'Edit mode'"
          aria-label="Toggle edit mode"
          role="button"
          @click="editMode = !editMode"
        ></b-icon>
      </div>
    </div>
    <div class="title-container" style="padding-top:0" v-if="reportDetails.sections">
      <b-form-radio-group
        id="btn-radios-sections"
        v-model="selectedSectionRadio"
        :options="options"
        button-variant="outline-primary"
        name="radios-btn-default"
        @change="onSelectSection"
        buttons
      ></b-form-radio-group>
    </div>
    <div v-if="reportDetails.sections" class="title-container" style="padding-top:0">
    <ul class="list-group page-group" v-for="section in reportDetails.sections" index="section.value" v-if="section.value == selectedSection">
      <li
        class="list-group-item page-item"
        :class="{ active: (page.value == selectedPage && page.slide == selectedSlide), 'is-hidden': (editMode && page.hidden) }"
        v-for="page in section.pages"
        index="page.name"
        v-show="editMode || !page.hidden"
        @click="onSelectPage(page)"
      >
        <span class="page-name">{{ page.name }}</span>
        <b-icon
          v-if="editMode"
          class="hide-toggle-icon"
          :icon="page.hidden ? 'eye-slash' : 'eye'"
          :title="page.hidden ? 'Unhide slide' : 'Hide slide'"
          @click.stop="onToggleHide(page)"
        ></b-icon>
      </li>
    </ul>
    </div>
  </div>
</template>


<script>
import { GetMixin } from "pinnacle-lib";

export default {
  mixins: [GetMixin],
  props: ["reportDetails","studyLocations", "selectSectionHandler", "selectPageHandler", "selectedSection", "selectedPage", "selectedSlide"],
  data() {
    return {
      selectedSectionRadio: false,
      editMode: false,
    }
  },
  mounted() {
    this.selectedSectionRadio = this.selectedSection
  },
  computed: {
    isAzira() {
      return this.$persistingStore.state.user?.company?.id === 1;
    },
    options() {
      let opts = this.reportDetails.sections.map(s => {return {text: s.name, value: s.value}});
      return opts;
    }
  },
  methods: {
    async onSelectSection(option) {
      this.$emit('selectSectionHandler', option);
    },
    async onSelectPage(page) {
      this.$emit('selectPageHandler', page);
    },
    async onToggleHide(page) {
      if (!this.isAzira || !this.editMode) return;

      const previous = !!page.hidden;
      const next = !previous;

      // Optimistic update
      this.$set(page, 'hidden', next);

      try {
        await this.postToURL(
          `/v2/insights/get-hotel-report/${this.reportDetails.id}/pages/${page.value}/visibility`,
          { hidden: next, slide: page.slide }
        );
        this.$emit('pageVisibilityChanged', { page, hidden: next });
      } catch (err) {
        // Roll back on failure
        this.$set(page, 'hidden', previous);
        this.$bvToast.toast(
          `Could not ${next ? 'hide' : 'unhide'} "${page.name}". Please try again.`,
          { title: 'Edit Mode', variant: 'danger' }
        );
      }
    },
  },
  watch: {
    selectedSection(val) {
      this.selectedSectionRadio = val;
    },
    editMode(val) {
      // Leaving edit mode may leave a hidden page selected; let the parent re-select.
      if (!val) {
        this.$emit('editModeChanged', val);
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.page-group {
  width:100%;
}
.page-item {
  background: #ffffff;
  cursor:pointer;
  width:100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.page-item:hover {
  background: #ccc;
  color: #fff;
  border-color: $cosmic;
  background-color: $cosmic;
}
.page-item.active {
  background-color: $slate;
  border-color: $slate;
}
.page-item.is-hidden {
  opacity: 0.5;
  font-style: italic;
}
.page-item .page-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.page-item .hide-toggle-icon {
  flex-shrink: 0;
  margin-left: 8px;
  cursor: pointer;
}

.table-of-contents-container {
  width: 100%;
}

.title-container {
  padding:15px 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .column {
    flex-direction: column;
  }
  .edit-mode-toggle {
    margin-left: auto;
    display: flex;
    align-items: center;
  }
  .edit-mode-icon {
    cursor: pointer;
    color: #adb5bd;
    font-size: 16px;
    transition: color 0.15s ease-in-out;
    &:hover {
      color: $cosmic;
    }
    &.active {
      color: $cosmic;
    }
  }
  .title {
    font-weight: bold;
    margin: auto 0;
    font-size: 16px;
  }
  .icon {
    display: flex;
    justify-content: center;
  }
  .number {
    font-weight: bold;
    margin: auto 0;
  }
  .elevio-placeholder {
    display: inline-block;
    top:18px;
    margin-left:3px;
    position: relative;
  }
}
</style>